export class CompanyPoint {
    public id=''
    public isDelete = ''
    public pointAmTime = ''
    public pointLatitude = ''
    public pointLongitude =''
    public pointName = ''
    public pointPmTime =''
    public pointRange =''
}